import PedidoForm from '../../spa/pedidosForm/PedidosForm';

export default {
  path: '/Pedidos/Form/:idPedido?',
  name: 'pedidoForm',
  component: PedidoForm
};



// WEBPACK FOOTER //
// ./src/config/router/pedidoForm.js